// MediaReplaceFlow component is not yet implemented in the native version,
// so we return an empty component instead.
export default () => null;
